import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import MuralFotoList from './MuralFotoList';
import { findByMuralCodigo } from './api-mural-foto';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { useSelector } from 'react-redux';
import { ADMIN, COORDENADOR, PROFESSOR } from '../../Usuario/Perfil';
import ImageFullScreenComponent from '../../UI/ImageFullScreenComponent';
import MuralFotoForm from './MuralFotoForm';

const useStyles = makeStyles({
    divMuralFotoForm: {
        borderColor: 'black',
        borderWidth: 'medium',
        borderStyle: 'solid',
        padding: '20px',
        margin: '20px',
    }
})

const MuralFotoContainer = ({ mural }) => {
    const classes = useStyles();
    const [muralFoto, setMuralFoto] = useState(null);
    const [muralFotos, setMuralFotos] = useState({
        content: [],
        size: 0,
        number: -1,
        totalPages: 0
    });
    const usuario = useSelector(state => state.usuario);
    const [uri, setUri] = useState(null);
    const [openFullWidth, setOpenFullWidth] = useState(false);

    useEffect(() => {
        findByMuralCodigo(mural.codigo, muralFotos.number + 1).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                if (!data.empty) {
                    setMuralFotos(prevState => ({
                        ...data,
                        content: [
                            ...prevState.content,
                            ...data.content
                        ]
                    }));
                }

            }
        })


    }, [mural.codigo, muralFotos.number]);

    const handleOpenFullImage = (valueUri) => {
        setOpenFullWidth(true);
        setUri(valueUri);
    }

    const handleClose = () => {
        setOpenFullWidth(false);
    }

    return (
        <Grid
            container
        >
            {openFullWidth ? <ImageFullScreenComponent
                uri={uri}
                handleClose={handleClose}
            /> :
                <>
                    {usuario.perfil === ADMIN ||
                        usuario.perfil === COORDENADOR ||
                        usuario.perfil === PROFESSOR ?
                        <div
                            className={classes.divMuralFotoForm}
                        >
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12
                                }}>
                                <MuralFotoForm
                                    mural={mural}
                                    muralFoto={muralFoto}
                                    setMuralFoto={setMuralFoto}
                                    setMuralFotos={setMuralFotos}
                                />
                            </Grid>
                        </div> : ''
                    }

                    <MuralFotoList
                        setMuralFoto={setMuralFoto}
                        muralFotos={muralFotos}
                        handleOpenFullImage={handleOpenFullImage}
                    />
                </>

            }
        </Grid>
    );
}

export default MuralFotoContainer;